import { useFeatureFlagEnabled } from "posthog-js/react";

import { POSTHOG_FEATURE_FLAGS } from "context/posthog/featureFlags";

export function useJAVAAccountsFeatureFlag() {
  return useFeatureFlagEnabled(POSTHOG_FEATURE_FLAGS.javaAccounts);
}
